import { Pipe, PipeTransform } from '@angular/core';
import { Depot } from '@app/state/interfaces';

@Pipe({ name: 'filterDepots' })
export class FilterDepotsPipe implements PipeTransform {
  transform(depots: Depot[], depotId?: string) {
    return depots.filter(depot => !depotId || depot.id === depotId);
  }
}
